import {Component, computed, input, InputSignal, Signal} from '@angular/core';

import {Formatter} from '@selpia/shared/utils';
import {Measure} from '@selpia/shared/models';

@Component({
  selector: 'lib-featured-value',
  standalone: true,
  templateUrl: './featured-value.component.html',
  styleUrl: './featured-value.component.scss',
  host: {
    '[attr.data-value]': 'value()',
    'data-test': 'focus-measure-value',
  },
})
export class FeaturedValueComponent {
  readonly value: InputSignal<number | undefined> = input.required();
  readonly measure: InputSignal<Measure | undefined> = input.required();
  readonly growthValue: InputSignal<number | undefined> = input();
  readonly growthMeasure: InputSignal<Measure | undefined> = input();
  readonly growthMeasureLabel: InputSignal<string | undefined> = input();

  protected readonly formattedValue: Signal<string> = computed(() => Formatter.formatByMeasure(this.value(), this.measure()));

  protected readonly formattedGrowthValue: Signal<string | undefined> = computed(() => {
    const value = this.growthValue();
    const measure = this.growthMeasure();

    if (!measure || value === undefined || value === null) {
      return undefined;
    }

    const label = this.growthMeasureLabel() ?? '';
    const formatted = Formatter.formatByMeasure(value, measure);

    return `${formatted} ${label}`.trim();
  });
}
